import { createLink } from "@tanstack/react-router"

import { Button } from "./Button"

export const LinkButton = createLink(Button)
